<div class="row row-sm add-form min">
    <div class="col-lg-12 ">
        <div class="card-body">
            <div class="bc d-flex align-items-center pl-3">
                <div class="ml-2">
                    <h3 class="main-content-label mb1"><b>
                            Students With Admission Fees Pending
                        </b></h3>
                </div>
            </div>

            <div class="row row-sm add-form mt-3">
                <!-- <h6>{{data.data.ReRgId}} {{data.data.RgName}}</h6> -->
                <div class="col-sm-12 pl-0">
                    <div>
                        <div class="table-responsive table-container" id="table">
                            <table class="table table-bordered text-nowrap">
                                <thead>
                                    <tr class="text-left">
                                        <th class="f600">
                                            First Name
                                        </th>
                                        <th class="f600">
                                            Middle Name
                                        </th>
                                        <th class="f600">
                                            Last Name
                                        </th>
                                        <th class="f600">
                                            Phone Number
                                        </th>
                                        <!-- <th class="f600">
                                            Total Fees
                                        </th> -->
                                        <th class="f600">
                                            Fees Status
                                        </th>
                                        
                                    </tr>
                                </thead>
                                <tbody class="curs">
                                    <!-- *ngFor="let item of examData" [class.selected-row]="item === selectedRow" (click)="selected(item)" -->
                                    <tr *ngFor="let item of studentGrid">
                                        <td>{{item.StuFirstNameEng}}</td>
                                        <td>{{item.StuMidNameEng}}</td>
                                        <td>{{item.StuLastNameEng}}</td>
                                        <td>{{item.StuNumber}}</td>
                                        <!-- <td>{{item.FeeAmt ? item.FeeAmt : 'Not Paid'}}</td> -->
                                        <td>{{item.TotalPaidAmount ? 'Pending'  : 'Pending'}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-8">

                    </div>
                    <div class="col-sm-4">
                        <button type="button" [mat-dialog-close]="true"
                            class="btn fr sz btn-primary btn-icon-text floatright mr-3 mt-1">
                            <span style="display: contents; align-items: center; margin-left:1rem;">
                                <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                Back
                            </span>
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>